import React from 'react';
import '../../Veridas/SuccessValidation/SuccessValidationForm.scss';
import ContainerValidation from "../../Dashboard/Visitor/External/Components/ContainerValidation";
import HeaderValidation from "../../Dashboard/Visitor/External/Components/HeaderValidation";
import BodyValidation from "../../Dashboard/Visitor/External/Components/BodyValidation";
import BuildingRegistrationSuccessApp from "./Functionality/BuildingRegistrationSuccessApp";
import {
    EmailSubsectionChip,
    IconCheckGif,
    IconDoor,
    ImgBuildingTree, OutlinedCalendarIcon,
    PersonOutlinedChip
} from "../../../components/buttons/IconButtons";
import CustomCard from "../../../components/CustomCard";
import {EMPTY_VALUES, getDateFormat} from "../../../Apis/functions";
import CustomGenericTittleIconDataChip from "../../../components/CustomGenericTittleIconDataChip";
import LocationCard from "../../Dashboard/Visitor/External/LocationCard";

/**
 *
 * Last step of the external building registration, it confirms the registration
 * and shows the summary of the data read from the validated document.
 *
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle : Full Stack Developer - IBL
 * @Email : kpozos@ibl.mx
 *
 */
const BuildingRegistrationSuccess = () => {

    const {
        t,
        registrationDetail,
        latLng,
        direction,
        setLatitude,
        setLongitude,
        handleSubmit
    } = BuildingRegistrationSuccessApp();

    return (
        <ContainerValidation>
            <HeaderValidation
                showBtnBack={false}
            />

            <BodyValidation
                click={() => {
                    handleSubmit();
                }}
                showBtnNext={true}
                showBtnPrev={false}
                classWith="content-center-w-600px gap-1"
                btnDisabled={false}
                textBtnNext={'exit_view'}
            >
                <div className={"d-grid gap-4 mb-4"}>
                    <div className={"d-flex justify-content-center"}>
                        <img src={IconCheckGif} alt={t("registration_complete")} height={54} width={54}/>
                    </div>
                    <div className="row">
                        <div className="col-12 d-flex flex-column justify-content-center align-items-center">
                            <p className="fs-24-to-18 ibl-font-w-600 font-color-general-950 text-center">{t("registration_complete")}</p>
                            <p className="fs-16-to-14 ibl-font-w-400 font-color-general-950 text-center">{`${t("your_registration_was_completed_successfully")} ${t("you_can_close_this_view")}`}</p>
                        </div>
                    </div>

                    <CustomCard classes={"w-100"} classCard={'card-border-8px border-0 p-10px box-shadow-shades-150-4-12px'} classContent={'p-0 m-0'}>
                        <CustomCard classCard={'card-border-8px'} classContent={'p-0'}>
                            <div className={"d-flex align-items-center p-3"}>
                                <div className="icons-invitation-start">
                                    <ImgBuildingTree className="w-100 h-100"/>
                                </div>

                                <p className={'fs-16-to-14 font-color-general-950 text-left pl-2'}>
                                    { registrationDetail?.buildingName || EMPTY_VALUES.DEFAULT }
                                </p>
                            </div>
                            <div className="border-bottom-shades-300" />
                            <div className={'row mt-4'}>

                                <div className={"col-sm-12 col-md-6 mb-3"}>
                                    <CustomGenericTittleIconDataChip
                                        title={'resident'}
                                        showAvatar={false}
                                        className={'px-0'}
                                    />
                                    <div className={"d-flex align-items-center mt-2"}>
                                        <div className={"d-flex align-items-center mr-2"}><PersonOutlinedChip/></div>
                                        <p className={"font-color-general-950 fs-14-to-13 "}>{ registrationDetail?.resident || EMPTY_VALUES.DEFAULT }</p>
                                    </div>

                                </div>
                                <div className={"col-sm-12 col-md-6 mb-3"}>
                                    <CustomGenericTittleIconDataChip
                                        title={'unit'}
                                        showAvatar={false}
                                        className={'px-0'}
                                    />
                                    <div className={"d-flex align-items-center mt-2"}>
                                        <div className={"d-flex align-items-center mr-2"}><IconDoor/></div>
                                        <p className={"font-color-general-950 fs-14-to-13 "}>{t("apt")} { registrationDetail?.unit || EMPTY_VALUES.DEFAULT }</p>
                                    </div>
                                </div>

                                <div className={"col-sm-12 col-md-6 mb-3"}>
                                    <CustomGenericTittleIconDataChip
                                        title={'confirmation_sent_to'}
                                        showAvatar={false}
                                        className={'px-0'}
                                    />
                                    <div className={"d-flex align-items-center mt-2"}>
                                        <div className={"d-flex align-items-center mr-2"}><EmailSubsectionChip/></div>
                                        <p className={"font-color-general-950 fs-14-to-13 "}>{ registrationDetail?.confirmationSentTo || EMPTY_VALUES.DEFAULT }</p>
                                    </div>
                                </div>

                                <div className={"col-sm-12 col-md-6 mb-3"}>
                                    <CustomGenericTittleIconDataChip
                                        title={'registration_date'}
                                        showAvatar={false}
                                        className={'px-0'}
                                    />
                                    <div className={"d-flex align-items-center mt-2"}>
                                        <div className={"d-flex align-items-center mr-2"}><OutlinedCalendarIcon width={16} height={16}/></div>
                                        <p className={"font-color-general-950 fs-14-to-13 "}>{ getDateFormat(registrationDetail?.registrationDate, false) || EMPTY_VALUES.DEFAULT }</p>
                                    </div>

                                </div>
                            </div>
                        </CustomCard>
                    </CustomCard>

                    <CustomCard classes="w-100 h-100 mb-2 z-index-3" classCard="card-border-8px border-0 p-10px box-shadow-shades-150-4-12px"  classContent="p-0">
                        {latLng?.length >= 2 &&
                        <LocationCard
                            t={t}
                            latlng={latLng}
                            setLatitude={setLatitude}
                            setLongitude={setLongitude}
                            location={direction || EMPTY_VALUES.DEFAULT}
                            classNameMap="h-125px w-100"
                            disabled={true}
                            title={"location"}
                        />
                        }
                    </CustomCard>
                </div>
            </BodyValidation>
        </ContainerValidation>
    );
};
export default BuildingRegistrationSuccess;
